import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NavLink } from 'rio-models';

@Component({
  selector: 'app-nav-links',
  imports: [RouterModule, MatTabsModule, TranslateModule],
  templateUrl: './nav-links.component.html',
  styleUrl: './nav-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavLinksComponent {
  @Input({ required: true }) navigation: NavLink[];
  @Input({ required: true }) activeUrl: string;
}
